$(function () {
    $(document).on("click", ".js-popup-close", function (e) {
        e.preventDefault();

        $.magnificPopup.close();
    });

    $(".js-open-video").magnificPopup({
        type: "iframe",
        closeBtnInside: false,
    });
});
